import type { WorkItem } from '../common/models';
import { useDebouncedSearch } from '../common/use-debounced-search';
import { searchWorkItems } from './api';

export const useWorkItemSearch = (query: string, delayMs = 300): { results: WorkItem[]; loading: boolean; error: Error | null } =>
    useDebouncedSearch<WorkItem>(query, searchWorkItems, delayMs);
